<script>
import { mapGetters, mapActions } from 'vuex';
import Room from './../../store/modules/room/types';
import Auth from './../../store/modules/auth/types';

export default {
  render: () => { return '' },
  name: 'RoomProvider',
  created () {
    if (!this.hasRooms()) {
      this.fetchRooms();
    }
  },
  watch: {
    logged () {
      console.log('RoomProvider FETCH');
      this.fetchRooms()
    }
  },
  computed: {
    logged () {
      return this.loggedIn();
    },
    ...mapGetters('Room', [Room.getters.HAS_ROOMS]),
    ...mapGetters('Auth', [Auth.getters.LOGGED_IN]),
  },
  methods: {
    ...mapActions('Room', [Room.actions.FETCH_ROOMS])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/providers/RoomProvider.vue